import React, { useEffect, useRef, useState } from 'react';
import {
  AquistaButton,
  AquistaButtonsContainer,
  CompanyInfoElements,
  CompanyInformationContainer,
  EuropeassistanceCardStyles,
  GuaranteesList,
  GuaranteesListItem,
  LeftCol,
  LogoContainer,
  LogoPriceContainer,
  Price,
  PriceContainer,
  QuoteInformationContainer,
  QuoteInformationItem,
  RightCol,
  SavedButton,
  SelectedGuaranteesContainer,
  AiChatButtonEuropeassistance,
} from '../ResultPageComponents/v2/EuropeassistanceCard.styles';
import { BACKEND_BASE_URL } from '../../../../config';
import GuaranteesModalTravel from '../Modal/GuaranteesModalTravel';
// import { SavedButton } from './common/Buttons.styles';
import SparklesIcon from '../../../../assets/images/icons/SparklesIcon';
import { Chat } from '../../chats/MiniChat/MiniChat';
import preContractIcon from '../../../../assets/redesign_icons/pre-contract-icon.svg';
import axe from '../../../../services/axios-client/axiosClient';
import { downloadFile } from '../../../../services/axios-client/axeHelpers';
import getChatSubProduct from '../../../helpers/getChatSubProduct';
import { getTravelCoverageText } from '../../../helpers/travelCoverages';

function EuropeassistanceCard({
  quote,
  guarantees,
  requestToken,
  insuranceRequest,
  selectQuotation,
  fetchData,
}) {
  const [openModal, setOpenModal] = useState(false);
  const [extraText, setExtraText] = useState(
    `Prezzo annuo: € ${parseFloat(quote.amount).toFixed(
      2,
    )} - Garanzie Aggiunte: `,
  );
  const [openChat, setOpenChat] = useState(false);
  const chatRef = useRef();

  const getPrice = () => {
    let price = quote.amount;
    const quoteCovs = [];

    for (let i = 0; i < guarantees.length; i++) {
      const quoteCov = guarantees[i];

      quoteCovs.push(quoteCov.guarantees_slug);
    }

    if (quoteCovs.length > 0) {
      const groupedCoverages = quote.quotation_data_travel_europeassistance.coverages.filter((e) => quoteCovs.includes(e.coverage_id));

      for (let x = 0; x < groupedCoverages.length; x++) {
        const cov = groupedCoverages[x];
        price -= cov.coverage_amount_gros;
      }
    }

    return price;
  };

  const downloadResourceDocs = async (producCode) => {
    const res = await axe.get(`/travel/informativa/${producCode}`, {
      responseType: 'blob',
    });

    downloadFile(res.data);
  };

  useEffect(() => {
    if (quote) {
      setExtraText(getTravelCoverageText(quote));
    }
  }, [quote]);
  return (
    <>
      {openModal && (
        <GuaranteesModalTravel
          setOpenModal={setOpenModal}
          quote={quote}
          guarantees={guarantees}
          requestToken={requestToken}
          insuranceRequest={insuranceRequest}
          fetchData={() => fetchData()}
        />
      )}
      <EuropeassistanceCardStyles className={insuranceRequest.processing_quotation_id === quote.id ? 'selected' : ''}>
        <LeftCol>
          <Chat
            ref={chatRef}
            openChat={openChat}
            setOpenChat={setOpenChat}
            company_id={quote.company_id}
            product_id={quote.product_id}
            quote_type={quote.quote_type}
            company_name={quote.company.name}
            extraText={extraText}
            sub_product={getChatSubProduct(quote)}
          />
          <LogoPriceContainer>
            <LogoContainer>
              <img
                src={BACKEND_BASE_URL + quote.company.logo}
                alt={`${quote.company.name} Logo`}
              />
            </LogoContainer>
            <PriceContainer>
              <Price>
                <h5>Prezzo annuo:</h5>
                <h2>
                  €
                  {parseFloat(getPrice()).toFixed(2)}
                </h2>
              </Price>
            </PriceContainer>
          </LogoPriceContainer>

          <CompanyInformationContainer>

            <CompanyInfoElements
              onClick={() => downloadResourceDocs(quote.quotation_data_travel_europeassistance
                .product_code, 0)}
              title="Informativa Precontrattuale "
            >
              <img src={preContractIcon} alt="" />
              <p>{'Informativa Precontrattuale '}</p>
            </CompanyInfoElements>
          </CompanyInformationContainer>

          <CompanyInformationContainer>
            {/* <CompanyInfoElements onClick={() => downloadResourceDocs(quote.quotation_data_travel_europeassistance.product_code)}>
              <img src={preContractIcon} alt="" />
              <p>Informazioni Precontrattuali</p>
            </CompanyInfoElements> */}
          </CompanyInformationContainer>
          <QuoteInformationContainer>
            <QuoteInformationItem>
              <h6>Prodotto:</h6>
              <p>{quote.quotation_data_travel_europeassistance.product_name}</p>
            </QuoteInformationItem>
            {quote.quotation_data_travel_europeassistance.coverages.map(
              (coverage, index) => (
                <React.Fragment key={index}>
                  {quote.quotation_data_travel_europeassistance.product_code === 'EA0177' && coverage.enabled === 0 && coverage.group_id === null && (
                    <QuoteInformationItem>
                      <h6>
                        {coverage.title}
                        :
                      </h6>
                      <p>{coverage.limit_desc}</p>
                    </QuoteInformationItem>
                  )}
                  {/** Mondo */}
                  {quote.quotation_data_travel_europeassistance.product_code === 'EA0190' && coverage.enabled === 0 && coverage.group_id === '1' && (
                    <QuoteInformationItem>
                      <h6>
                        {coverage.title}
                        :
                      </h6>
                      <p>{coverage.limit_desc}</p>
                    </QuoteInformationItem>
                  )}
                  {/* {quote.quotation_coverages.map(
                    (cov, index) => coverage.coverage_id === cov.guarantees_slug && (
                      <QuoteInformationItem key={index}>
                        <h6>
                          {coverage.title}
                          :
                        </h6>
                        <p>{coverage.limit_desc}</p>
                      </QuoteInformationItem>
                    ),
                  )} */}
                </React.Fragment>
              ),
            )}
          </QuoteInformationContainer>
        </LeftCol>
        <RightCol>
          <div style={{ alignSelf: 'flex-end', marginBottom: '10px' }}>
            <AiChatButtonEuropeassistance onClick={() => setOpenChat(true)}>
              <SparklesIcon width={24} height={24} />
              <span>Chiedi all'AI</span>
            </AiChatButtonEuropeassistance>
          </div>
          <SelectedGuaranteesContainer>
            <h2>
              <b>Garanzie</b>
              {' '}
              Aggiunte
            </h2>
            <GuaranteesList style={{ height: 'unset !important' }}>
              {quote.quotation_data_travel_europeassistance.coverages.map(
                (coverage, index) => (
                  <React.Fragment key={index}>
                    {quote.quotation_data_travel_europeassistance.product_code === 'EA0177' && coverage.enabled === 0 && coverage.group_id === null && (
                      <GuaranteesListItem>
                        <h6>
                          <span />
                          {' '}
                          {coverage.title}
                        </h6>
                        <p>
                          &euro;
                          {parseFloat(
                            coverage.coverage_amount_gros,
                          ).toLocaleString('en-US')}
                        </p>
                      </GuaranteesListItem>
                    )}
                    {quote.quotation_data_travel_europeassistance.product_code === 'EA0190' && coverage.enabled === 0 && coverage.group_id === '1' && (
                      <GuaranteesListItem>
                        <h6>
                          <span />
                          {' '}
                          {coverage.title}
                        </h6>
                        <p>
                          &euro;
                          {parseFloat(
                            coverage.coverage_amount_gros,
                          ).toLocaleString('en-US')}
                        </p>
                      </GuaranteesListItem>
                    )}
                    {/* {quote.quotation_coverages.map(
                      (cov, index) => coverage.coverage_id === cov.guarantees_slug && (
                        <GuaranteesListItem key={index}>
                          <h6>
                            <span />
                            {' '}
                            {cov.guarantees_description}
                          </h6>
                          <p>
                            &euro;
                            {parseFloat(cov.amount).toLocaleString('en-US')}
                          </p>
                        </GuaranteesListItem>
                      ),
                    )} */}
                  </React.Fragment>
                ),
              )}
            </GuaranteesList>
          </SelectedGuaranteesContainer>
          <AquistaButtonsContainer>
            {/* <AddGuaranteesButton
              onClick={() => setOpenModal(true)}
              className="result-travel-fourth-step"
            >
              Seleziona Garanzie
            </AddGuaranteesButton> */}
            {insuranceRequest.processing_quotation_id !== quote.id ? (
              <AquistaButton
                onClick={() => selectQuotation(quote.id)}
                className="result-travel-fifth-step"
              >
                Seleziona
              </AquistaButton>
            ) : (
              insuranceRequest.processing_quotation_id === quote.id && (
                <SavedButton>Aggiunto</SavedButton>
              )
            )}
          </AquistaButtonsContainer>
        </RightCol>
      </EuropeassistanceCardStyles>
    </>
  );
}

export default EuropeassistanceCard;
